/**
 * Status-line classification (issue #76): distinguishes a hard-constraint-#7
 * BLOCKER report from routine status chatter (tile counts, jump
 * confirmations) so the caller can keep it fully visible and styled
 * distinctly rather than folding it into the compact bottom strip.
 */
export function isBlockerStatus(text: string): boolean {
  return text.startsWith('BLOCKER:');
}
